import { getGdocApiUrl } from './googleDocsUtils'
import { getAccessToken, googleOauth2 } from './googleUtils'

const importFromGoogle = async (url: string) => {
  await googleOauth2(window.location.href, window.location.origin)
  const apiUrl = getGdocApiUrl(url)

  const reqBody = JSON.stringify({
    apiUrl,
    accessToken: getAccessToken(),
    apiMethod: 'GET',
    textResponse: true,
  })

  const res = await fetch('/api/googleRest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: reqBody,
  })

  const html = await res.text()

  return html
}

const useImportFromGoogle = () => {
  return { importFromGoogle }
}

export const goolgleDocsLink = 'https://docs.google.com/document/d/'
export default useImportFromGoogle
